var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectStreamBackImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 297.298,
    height: 306.88,
    viewBox: "0 0 297.298 306.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6568",
    "data-name": "Path 6568",
    d: "M1222.908,146.147c0,64.767,53.04,117.271,118.468,117.271s118.468-52.5,118.468-117.271S1406.8,28.876,1341.376,28.876s-118.468,52.5-118.468,117.271",
    transform: "translate(-1222.908 -28.876)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44436",
    "data-name": "Group 44436",
    transform: "translate(18.829 -801.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6570",
    "data-name": "Path 6570",
    d: "M89.415,0A89.415,89.415,0,1,1,0,89.415,89.415,89.415,0,0,1,89.415,0Z",
    transform: "translate(-18.829 801.998)",
    fill: "#d9d9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2520",
    "data-name": "Group 2520",
    transform: "translate(-1181.376 845.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2518",
    "data-name": "Group 2518",
    transform: "translate(1222.908 28.876)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6424",
    "data-name": "Path 6424",
    d: "M1214.015,733.3h-30.677V702.937h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1195.476 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6425",
    "data-name": "Path 6425",
    d: "M1213.129,732.418h-32.084V700.644h32.084Zm-30.174-1.905h28.264V702.548h-28.264Z",
    transform: "translate(-1193.887 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6426",
    "data-name": "Path 6426",
    d: "M1312.426,733.3h-30.677V702.937h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1263.699 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6427",
    "data-name": "Path 6427",
    d: "M1311.538,732.418h-32.084V700.644h32.084Zm-30.174-1.905h28.264V702.548h-28.264Z",
    transform: "translate(-1262.108 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6428",
    "data-name": "Path 6428",
    d: "M1410.791,733.3h-30.677V702.937h30.677Zm-.5-.5V703.435h-29.671v29.371Z",
    transform: "translate(-1331.891 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6429",
    "data-name": "Path 6429",
    d: "M1409.9,732.418H1377.82V700.644H1409.9Zm-30.174-1.905h28.264V702.548H1379.73Z",
    transform: "translate(-1330.3 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6430",
    "data-name": "Path 6430",
    d: "M1509.157,733.3H1478.48V702.937h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1400.083 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6431",
    "data-name": "Path 6431",
    d: "M1508.27,732.418h-32.084V700.644h32.084Zm-30.173-1.905h28.264V702.548H1478.1Z",
    transform: "translate(-1398.492 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6432",
    "data-name": "Path 6432",
    d: "M1607.523,733.3h-30.677V702.937h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1468.275 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6433",
    "data-name": "Path 6433",
    d: "M1606.637,732.418h-32.084V700.644h32.084Zm-30.174-1.905h28.264V702.548h-28.264Z",
    transform: "translate(-1466.685 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6434",
    "data-name": "Path 6434",
    d: "M1706.139,733.3h-30.677V702.937h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1536.64 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6435",
    "data-name": "Path 6435",
    d: "M1705.253,732.418h-32.084V700.644h32.084Zm-30.174-1.905h28.264V702.548h-28.264Z",
    transform: "translate(-1535.05 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6436",
    "data-name": "Path 6436",
    d: "M1804.549,702.937V733.3h-30.677V702.937Zm-.5.5h-29.671v29.371h29.671Z",
    transform: "translate(-1604.862 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6437",
    "data-name": "Path 6437",
    d: "M1803.662,732.418h-32.085V700.644h32.085Zm-30.174-1.905h28.264V702.548h-28.264Z",
    transform: "translate(-1603.272 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6438",
    "data-name": "Path 6438",
    d: "M1902.916,733.3h-30.677V702.937h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1673.055 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6439",
    "data-name": "Path 6439",
    d: "M1902.029,732.418h-32.084V700.644h32.084Zm-30.174-1.905h28.264V702.548h-28.264Z",
    transform: "translate(-1671.464 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6440",
    "data-name": "Path 6440",
    d: "M2001.281,733.3H1970.6V702.937h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1741.246 -496.167)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6441",
    "data-name": "Path 6441",
    d: "M2000.394,732.418H1968.31V700.644h32.084Zm-30.174-1.905h28.264V702.548H1970.22Z",
    transform: "translate(-1739.656 -494.577)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6442",
    "data-name": "Path 6442",
    d: "M1214.015,636.315h-30.677V605.948h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1195.476 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6443",
    "data-name": "Path 6443",
    d: "M1213.129,635.429h-32.084V603.655h32.084Zm-30.174-1.9h28.264V605.56h-28.264Z",
    transform: "translate(-1193.887 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6444",
    "data-name": "Path 6444",
    d: "M1312.426,636.315h-30.677V605.948h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1263.699 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6445",
    "data-name": "Path 6445",
    d: "M1311.538,635.429h-32.084V603.655h32.084Zm-30.174-1.9h28.264V605.56h-28.264Z",
    transform: "translate(-1262.108 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6446",
    "data-name": "Path 6446",
    d: "M1410.792,636.315h-30.677V605.948h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1331.891 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6447",
    "data-name": "Path 6447",
    d: "M1409.9,635.429H1377.82V603.655H1409.9Zm-30.174-1.9h28.264V605.56H1379.73Z",
    transform: "translate(-1330.3 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6448",
    "data-name": "Path 6448",
    d: "M1509.157,636.315H1478.48V605.948h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1400.083 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6449",
    "data-name": "Path 6449",
    d: "M1508.27,635.429h-32.084V603.655h32.084Zm-30.173-1.9h28.264V605.56H1478.1Z",
    transform: "translate(-1398.492 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6450",
    "data-name": "Path 6450",
    d: "M1607.523,636.315h-30.677V605.948h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1468.275 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6451",
    "data-name": "Path 6451",
    d: "M1606.637,635.429h-32.084V603.655h32.084Zm-30.174-1.9h28.264V605.56h-28.264Z",
    transform: "translate(-1466.685 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6452",
    "data-name": "Path 6452",
    d: "M1706.139,636.315h-30.677V605.948h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1536.64 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6453",
    "data-name": "Path 6453",
    d: "M1705.253,635.429h-32.084V603.655h32.084Zm-30.174-1.9h28.264V605.56h-28.264Z",
    transform: "translate(-1535.05 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6454",
    "data-name": "Path 6454",
    d: "M1804.55,636.315h-30.677V605.948h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1604.863 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6455",
    "data-name": "Path 6455",
    d: "M1803.662,635.429h-32.085V603.655h32.085Zm-30.174-1.9h28.264V605.56h-28.264Z",
    transform: "translate(-1603.272 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6456",
    "data-name": "Path 6456",
    d: "M1902.916,636.315h-30.677V605.948h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1673.055 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6457",
    "data-name": "Path 6457",
    d: "M1902.029,635.429h-32.084V603.655h32.084Zm-30.174-1.9h28.264V605.56h-28.264Z",
    transform: "translate(-1671.464 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6458",
    "data-name": "Path 6458",
    d: "M2001.281,636.315H1970.6V605.948h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1741.246 -428.93)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6459",
    "data-name": "Path 6459",
    d: "M2000.394,635.429H1968.31V603.655h32.084Zm-30.174-1.9h28.264V605.56H1970.22Z",
    transform: "translate(-1739.656 -427.34)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6460",
    "data-name": "Path 6460",
    d: "M1214.015,539.086h-30.677V508.719h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1195.476 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6461",
    "data-name": "Path 6461",
    d: "M1213.129,538.2h-32.084V506.426h32.084Zm-30.174-1.905h28.264V508.331h-28.264Z",
    transform: "translate(-1193.887 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6462",
    "data-name": "Path 6462",
    d: "M1312.426,539.086h-30.677V508.719h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1263.699 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6463",
    "data-name": "Path 6463",
    d: "M1311.538,538.2h-32.084V506.426h32.084Zm-30.174-1.905h28.264V508.331h-28.264Z",
    transform: "translate(-1262.108 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6464",
    "data-name": "Path 6464",
    d: "M1410.792,539.086h-30.677V508.719h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1331.891 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6465",
    "data-name": "Path 6465",
    d: "M1409.9,538.2H1377.82V506.426H1409.9ZM1379.73,536.3h28.264V508.331H1379.73Z",
    transform: "translate(-1330.3 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6466",
    "data-name": "Path 6466",
    d: "M1509.157,539.086H1478.48V508.719h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1400.083 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6467",
    "data-name": "Path 6467",
    d: "M1508.27,538.2h-32.084V506.426h32.084ZM1478.1,536.3h28.264V508.331H1478.1Z",
    transform: "translate(-1398.492 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6468",
    "data-name": "Path 6468",
    d: "M1607.523,539.086h-30.677V508.719h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1468.275 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6469",
    "data-name": "Path 6469",
    d: "M1606.637,538.2h-32.084V506.426h32.084Zm-30.174-1.905h28.264V508.331h-28.264Z",
    transform: "translate(-1466.685 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6470",
    "data-name": "Path 6470",
    d: "M1706.139,539.086h-30.677V508.719h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1536.64 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6471",
    "data-name": "Path 6471",
    d: "M1705.253,538.2h-32.084V506.426h32.084Zm-30.174-1.905h28.264V508.331h-28.264Z",
    transform: "translate(-1535.05 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6472",
    "data-name": "Path 6472",
    d: "M1804.55,539.086h-30.677V508.719h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1604.863 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6473",
    "data-name": "Path 6473",
    d: "M1803.662,538.2h-32.085V506.426h32.085Zm-30.174-1.905h28.264V508.331h-28.264Z",
    transform: "translate(-1603.272 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6474",
    "data-name": "Path 6474",
    d: "M1902.916,539.086h-30.677V508.719h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1673.055 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6475",
    "data-name": "Path 6475",
    d: "M1902.029,538.2h-32.084V506.426h32.084Zm-30.174-1.905h28.264V508.331h-28.264Z",
    transform: "translate(-1671.464 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6476",
    "data-name": "Path 6476",
    d: "M2001.281,539.086H1970.6V508.719h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1741.246 -361.526)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6477",
    "data-name": "Path 6477",
    d: "M2000.394,538.2H1968.31V506.426h32.084ZM1970.22,536.3h28.264V508.331H1970.22Z",
    transform: "translate(-1739.656 -359.936)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6478",
    "data-name": "Path 6478",
    d: "M1214.015,442.1h-30.677V411.731h30.677Zm-.5-29.869h-29.671V441.6h29.671Z",
    transform: "translate(-1195.476 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6479",
    "data-name": "Path 6479",
    d: "M1213.129,441.211h-32.084V409.437h32.084Zm-30.174-1.905h28.264V411.342h-28.264Z",
    transform: "translate(-1193.887 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6480",
    "data-name": "Path 6480",
    d: "M1312.426,442.1h-30.677V411.731h30.677Zm-.5-29.869h-29.671V441.6h29.671Z",
    transform: "translate(-1263.699 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6481",
    "data-name": "Path 6481",
    d: "M1311.538,441.211h-32.084V409.437h32.084Zm-30.174-1.905h28.264V411.342h-28.264Z",
    transform: "translate(-1262.108 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6482",
    "data-name": "Path 6482",
    d: "M1410.792,442.1h-30.677V411.731h30.677Zm-.5-29.869h-29.671V441.6h29.671Z",
    transform: "translate(-1331.891 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6483",
    "data-name": "Path 6483",
    d: "M1409.9,441.211H1377.82V409.437H1409.9Zm-30.174-1.905h28.264V411.342H1379.73Z",
    transform: "translate(-1330.3 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6484",
    "data-name": "Path 6484",
    d: "M1509.157,442.1H1478.48V411.731h30.677Zm-.5-29.869h-29.671V441.6h29.671Z",
    transform: "translate(-1400.083 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6485",
    "data-name": "Path 6485",
    d: "M1508.27,441.211h-32.084V409.437h32.084Zm-30.173-1.905h28.264V411.342H1478.1Z",
    transform: "translate(-1398.492 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6486",
    "data-name": "Path 6486",
    d: "M1607.523,442.1h-30.677V411.731h30.677Zm-.5-29.869h-29.671V441.6h29.671Z",
    transform: "translate(-1468.275 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6487",
    "data-name": "Path 6487",
    d: "M1606.637,441.211h-32.084V409.437h32.084Zm-30.174-1.905h28.264V411.342h-28.264Z",
    transform: "translate(-1466.685 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6488",
    "data-name": "Path 6488",
    d: "M1706.139,442.1h-30.677V411.731h30.677Zm-.5-29.869h-29.671V441.6h29.671Z",
    transform: "translate(-1536.64 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6489",
    "data-name": "Path 6489",
    d: "M1705.253,441.211h-32.084V409.437h32.084Zm-30.174-1.905h28.264V411.342h-28.264Z",
    transform: "translate(-1535.05 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6490",
    "data-name": "Path 6490",
    d: "M1804.55,442.1h-30.677V411.731h30.677Zm-.5-29.869h-29.671V441.6h29.671Z",
    transform: "translate(-1604.863 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6491",
    "data-name": "Path 6491",
    d: "M1803.662,441.211h-32.085V409.437h32.085Zm-30.174-1.905h28.264V411.342h-28.264Z",
    transform: "translate(-1603.272 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6492",
    "data-name": "Path 6492",
    d: "M1902.916,442.1h-30.677V411.731h30.677Zm-.5-29.869h-29.671V441.6h29.671Z",
    transform: "translate(-1673.055 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6493",
    "data-name": "Path 6493",
    d: "M1902.029,441.211h-32.084V409.437h32.084Zm-30.174-1.905h28.264V411.342h-28.264Z",
    transform: "translate(-1671.464 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6494",
    "data-name": "Path 6494",
    d: "M2001.281,442.1H1970.6V411.731h30.677Zm-.5-29.869h-29.671V441.6h29.671Z",
    transform: "translate(-1741.246 -294.289)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6495",
    "data-name": "Path 6495",
    d: "M2000.394,441.211H1968.31V409.437h32.084Zm-30.174-1.905h28.264V411.342H1970.22Z",
    transform: "translate(-1739.656 -292.699)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6496",
    "data-name": "Path 6496",
    d: "M1214.015,344.666h-30.677V314.3h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1195.476 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6497",
    "data-name": "Path 6497",
    d: "M1213.129,343.78h-32.084V312.006h32.084Zm-30.174-1.905h28.264V313.911h-28.264Z",
    transform: "translate(-1193.887 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6498",
    "data-name": "Path 6498",
    d: "M1312.426,344.666h-30.677V314.3h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1263.699 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6499",
    "data-name": "Path 6499",
    d: "M1311.538,343.78h-32.084V312.006h32.084Zm-30.174-1.905h28.264V313.911h-28.264Z",
    transform: "translate(-1262.108 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6500",
    "data-name": "Path 6500",
    d: "M1410.792,344.666h-30.677V314.3h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1331.891 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6501",
    "data-name": "Path 6501",
    d: "M1409.9,343.78H1377.82V312.006H1409.9Zm-30.174-1.905h28.264V313.911H1379.73Z",
    transform: "translate(-1330.3 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6502",
    "data-name": "Path 6502",
    d: "M1509.157,344.666H1478.48V314.3h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1400.083 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6503",
    "data-name": "Path 6503",
    d: "M1508.27,343.78h-32.084V312.006h32.084Zm-30.173-1.905h28.264V313.911H1478.1Z",
    transform: "translate(-1398.492 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6504",
    "data-name": "Path 6504",
    d: "M1607.523,344.666h-30.677V314.3h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1468.275 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6505",
    "data-name": "Path 6505",
    d: "M1606.637,343.78h-32.084V312.006h32.084Zm-30.174-1.905h28.264V313.911h-28.264Z",
    transform: "translate(-1466.685 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6506",
    "data-name": "Path 6506",
    d: "M1706.139,344.666h-30.677V314.3h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1536.64 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6507",
    "data-name": "Path 6507",
    d: "M1705.253,343.78h-32.084V312.006h32.084Zm-30.174-1.905h28.264V313.911h-28.264Z",
    transform: "translate(-1535.05 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6508",
    "data-name": "Path 6508",
    d: "M1804.55,344.666h-30.677V314.3h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1604.863 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6509",
    "data-name": "Path 6509",
    d: "M1803.662,343.78h-32.085V312.006h32.085Zm-30.174-1.905h28.264V313.911h-28.264Z",
    transform: "translate(-1603.272 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6510",
    "data-name": "Path 6510",
    d: "M1902.916,344.666h-30.677V314.3h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1673.055 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6511",
    "data-name": "Path 6511",
    d: "M1902.029,343.78h-32.084V312.006h32.084Zm-30.174-1.905h28.264V313.911h-28.264Z",
    transform: "translate(-1671.464 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6512",
    "data-name": "Path 6512",
    d: "M2001.281,344.666H1970.6V314.3h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1741.246 -226.745)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6513",
    "data-name": "Path 6513",
    d: "M2000.394,343.78H1968.31V312.006h32.084Zm-30.174-1.905h28.264V313.911H1970.22Z",
    transform: "translate(-1739.656 -225.155)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6514",
    "data-name": "Path 6514",
    d: "M1214.015,247.675h-30.677V217.308h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1195.476 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6515",
    "data-name": "Path 6515",
    d: "M1213.129,246.787h-32.084V215.013h32.084Zm-30.174-1.9h28.264V216.918h-28.264Z",
    transform: "translate(-1193.887 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6516",
    "data-name": "Path 6516",
    d: "M1312.426,247.675h-30.677V217.308h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1263.699 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6517",
    "data-name": "Path 6517",
    d: "M1311.538,246.787h-32.084V215.013h32.084Zm-30.174-1.9h28.264V216.918h-28.264Z",
    transform: "translate(-1262.108 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6518",
    "data-name": "Path 6518",
    d: "M1410.792,247.675h-30.677V217.308h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1331.891 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6519",
    "data-name": "Path 6519",
    d: "M1409.9,246.787H1377.82V215.013H1409.9Zm-30.174-1.9h28.264V216.918H1379.73Z",
    transform: "translate(-1330.3 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6520",
    "data-name": "Path 6520",
    d: "M1509.157,247.675H1478.48V217.308h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1400.083 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6521",
    "data-name": "Path 6521",
    d: "M1508.27,246.787h-32.084V215.013h32.084Zm-30.173-1.9h28.264V216.918H1478.1Z",
    transform: "translate(-1398.492 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6522",
    "data-name": "Path 6522",
    d: "M1607.523,247.675h-30.677V217.308h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1468.275 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6523",
    "data-name": "Path 6523",
    d: "M1606.637,246.787h-32.084V215.013h32.084Zm-30.174-1.9h28.264V216.918h-28.264Z",
    transform: "translate(-1466.685 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6524",
    "data-name": "Path 6524",
    d: "M1706.139,247.675h-30.677V217.308h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1536.64 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6525",
    "data-name": "Path 6525",
    d: "M1705.253,246.787h-32.084V215.013h32.084Zm-30.174-1.9h28.264V216.918h-28.264Z",
    transform: "translate(-1535.05 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6526",
    "data-name": "Path 6526",
    d: "M1804.55,247.675h-30.677V217.308h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1604.863 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6527",
    "data-name": "Path 6527",
    d: "M1803.662,246.787h-32.085V215.013h32.085Zm-30.174-1.9h28.264V216.918h-28.264Z",
    transform: "translate(-1603.272 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6528",
    "data-name": "Path 6528",
    d: "M1902.916,247.675h-30.677V217.308h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1673.055 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6529",
    "data-name": "Path 6529",
    d: "M1902.029,246.787h-32.084V215.013h32.084Zm-30.174-1.9h28.264V216.918h-28.264Z",
    transform: "translate(-1671.464 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6530",
    "data-name": "Path 6530",
    d: "M2001.281,247.675H1970.6V217.308h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1741.246 -159.506)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6531",
    "data-name": "Path 6531",
    d: "M2000.394,246.787H1968.31V215.013h32.084Zm-30.174-1.9h28.264V216.918H1970.22Z",
    transform: "translate(-1739.656 -157.915)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6532",
    "data-name": "Path 6532",
    d: "M1214.015,150.449h-30.677V120.082h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1195.476 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6533",
    "data-name": "Path 6533",
    d: "M1213.129,149.562h-32.084V117.788h32.084Zm-30.174-1.905h28.264V119.693h-28.264Z",
    transform: "translate(-1193.887 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6534",
    "data-name": "Path 6534",
    d: "M1312.426,150.449h-30.677V120.082h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1263.699 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6535",
    "data-name": "Path 6535",
    d: "M1311.538,149.562h-32.084V117.788h32.084Zm-30.174-1.905h28.264V119.693h-28.264Z",
    transform: "translate(-1262.108 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6536",
    "data-name": "Path 6536",
    d: "M1410.792,150.449h-30.677V120.082h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1331.891 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6537",
    "data-name": "Path 6537",
    d: "M1409.9,149.562H1377.82V117.788H1409.9Zm-30.174-1.905h28.264V119.693H1379.73Z",
    transform: "translate(-1330.3 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6538",
    "data-name": "Path 6538",
    d: "M1509.157,150.449H1478.48V120.082h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1400.083 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6539",
    "data-name": "Path 6539",
    d: "M1508.27,149.562h-32.084V117.788h32.084Zm-30.173-1.905h28.264V119.693H1478.1Z",
    transform: "translate(-1398.492 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6540",
    "data-name": "Path 6540",
    d: "M1607.523,150.449h-30.677V120.082h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1468.275 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6541",
    "data-name": "Path 6541",
    d: "M1606.637,149.562h-32.084V117.788h32.084Zm-30.174-1.905h28.264V119.693h-28.264Z",
    transform: "translate(-1466.685 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6542",
    "data-name": "Path 6542",
    d: "M1706.139,150.449h-30.677V120.082h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1536.64 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6543",
    "data-name": "Path 6543",
    d: "M1705.253,149.562h-32.084V117.788h32.084Zm-30.174-1.905h28.264V119.693h-28.264Z",
    transform: "translate(-1535.05 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6544",
    "data-name": "Path 6544",
    d: "M1804.55,150.449h-30.677V120.082h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1604.863 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6545",
    "data-name": "Path 6545",
    d: "M1803.662,149.562h-32.085V117.788h32.085Zm-30.174-1.905h28.264V119.693h-28.264Z",
    transform: "translate(-1603.272 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6546",
    "data-name": "Path 6546",
    d: "M1902.916,150.449h-30.677V120.082h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1673.055 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6547",
    "data-name": "Path 6547",
    d: "M1902.029,149.562h-32.084V117.788h32.084Zm-30.174-1.905h28.264V119.693h-28.264Z",
    transform: "translate(-1671.464 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6548",
    "data-name": "Path 6548",
    d: "M2001.281,150.449H1970.6V120.082h30.677Zm-.5-29.869h-29.671v29.371h29.671Z",
    transform: "translate(-1741.246 -92.104)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6549",
    "data-name": "Path 6549",
    d: "M2000.394,149.562H1968.31V117.788h32.084Zm-30.174-1.905h28.264V119.693H1970.22Z",
    transform: "translate(-1739.656 -90.514)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6550",
    "data-name": "Path 6550",
    d: "M1214.015,53.457h-30.677V23.09h30.677Zm-.5-29.869h-29.671V52.959h29.671Z",
    transform: "translate(-1195.476 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6551",
    "data-name": "Path 6551",
    d: "M1213.129,52.571h-32.084V20.8h32.084Zm-30.174-1.905h28.264V22.7h-28.264Z",
    transform: "translate(-1193.887 -23.275)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6552",
    "data-name": "Path 6552",
    d: "M1312.426,53.457h-30.677V23.09h30.677Zm-.5-29.869h-29.671V52.959h29.671Z",
    transform: "translate(-1263.699 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6553",
    "data-name": "Path 6553",
    d: "M1311.538,52.571h-32.084V20.8h32.084Zm-30.174-1.905h28.264V22.7h-28.264Z",
    transform: "translate(-1262.108 -23.275)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6554",
    "data-name": "Path 6554",
    d: "M1410.792,53.457h-30.677V23.09h30.677Zm-.5-29.869h-29.671V52.959h29.671Z",
    transform: "translate(-1331.891 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6555",
    "data-name": "Path 6555",
    d: "M1409.9,52.571H1377.82V20.8H1409.9Zm-30.174-1.905h28.264V22.7H1379.73Z",
    transform: "translate(-1330.3 -23.275)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6556",
    "data-name": "Path 6556",
    d: "M1509.157,53.457H1478.48V23.09h30.677Zm-.5-29.869h-29.671V52.959h29.671Z",
    transform: "translate(-1400.083 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6557",
    "data-name": "Path 6557",
    d: "M1508.27,52.571h-32.084V20.8h32.084ZM1478.1,50.666h28.264V22.7H1478.1Z",
    transform: "translate(-1398.492 -23.275)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6558",
    "data-name": "Path 6558",
    d: "M1607.523,53.457h-30.677V23.09h30.677Zm-.5-29.869h-29.671V52.959h29.671Z",
    transform: "translate(-1468.275 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6559",
    "data-name": "Path 6559",
    d: "M1606.637,52.571h-32.084V20.8h32.084Zm-30.174-1.905h28.264V22.7h-28.264Z",
    transform: "translate(-1466.685 -23.275)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6560",
    "data-name": "Path 6560",
    d: "M1706.139,53.457h-30.677V23.09h30.677Zm-.5-29.869h-29.671V52.959h29.671Z",
    transform: "translate(-1536.64 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6561",
    "data-name": "Path 6561",
    d: "M1705.253,52.571h-32.084V20.8h32.084Zm-30.174-1.905h28.264V22.7h-28.264Z",
    transform: "translate(-1535.05 -23.275)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6562",
    "data-name": "Path 6562",
    d: "M1804.55,53.457h-30.677V23.09h30.677Zm-.5-29.869h-29.671V52.959h29.671Z",
    transform: "translate(-1604.863 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6563",
    "data-name": "Path 6563",
    d: "M1803.662,52.571h-32.085V20.8h32.085Zm-30.174-1.905h28.264V22.7h-28.264Z",
    transform: "translate(-1603.272 -23.275)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6564",
    "data-name": "Path 6564",
    d: "M1902.916,53.457h-30.677V23.09h30.677Zm-.5-29.869h-29.671V52.959h29.671Z",
    transform: "translate(-1673.055 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6565",
    "data-name": "Path 6565",
    d: "M1902.029,52.571h-32.084V20.8h32.084Zm-30.174-1.905h28.264V22.7h-28.264Z",
    transform: "translate(-1671.464 -23.275)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6566",
    "data-name": "Path 6566",
    d: "M2001.281,53.457H1970.6V23.09h30.677Zm-.5-29.869h-29.671V52.959h29.671Z",
    transform: "translate(-1741.246 -24.865)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6567",
    "data-name": "Path 6567",
    d: "M2000.394,52.571H1968.31V20.8h32.084Zm-30.174-1.905h28.264V22.7H1970.22Z",
    transform: "translate(-1739.656 -23.275)",
    fill: "#c5c5ff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectStreamBackImg);
export default __webpack_public_path__ + "static/media/selectStreamBackImg.72508f22d538a48c257a45ff3b1bdeb4.svg";
export { ForwardRef as ReactComponent };